import { render } from "./Associate.vue?vue&type=template&id=a98743aa"
import script from "./Associate.vue?vue&type=script&lang=js"
export * from "./Associate.vue?vue&type=script&lang=js"

import "./Associate.vue?vue&type=style&index=0&id=a98743aa&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__